import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';

const initSliderPost = (id: string): void => {

  new Swiper(`${id} .swiper`, {
    modules: [Navigation, Pagination, Keyboard],
    navigation: {
      nextEl: `${id} .swiper-button-next`,
      prevEl: `${id} .swiper-button-prev`
    },
    pagination: {
      el: `${id} .swiper-pagination`
    },
    keyboard: true,
    loop: true
  });
};

export default initSliderPost;
